/**
 * The label for a code the backend will own (states, reasons, origins). Seeded
 * codes translate. A code that arrives before its label gets a generic "needs
 * attention" label — never the raw code, which an owner must not see — and a
 * warning in development. `t(key, { defaultValue })` does not help, because
 * the missing-key handler throws first. Check, then ask.
 */
export function codeLabel(
  i18n: { exists: (key: string) => boolean },
  t: (key: string, params: Record<string, unknown>) => string,
  key: string,
  code: string,
  params: Record<string, unknown> = {},
): string {
  if (i18n.exists(key)) return t(key, params);
  if (import.meta.env.DEV) console.warn(`[accounting] no label for ${code} (${key})`);
  return t("accounting:fallback.unknown", {});
}
